<template>
  <div>
    <dl class="row px-3 px-sm-5 pt-3 mb-0">
      <dt class="no-colon d-print-none w-xs-100">Aksiyon Seçiniz</dt>
      <dd class="single d-print-none w-xs-100 pl-1 pl-sm-0">
        <form id="updateSuggestionResultForm">
          <input
            name="__RequestVerificationToken"
            type="hidden"
            value="VBrI4HoiLXlnxE0_6rh2XqoVmlmwWYWKyPlQdVW-THoJxa40c7UcJv4nZZGeC8TmRAoXc1M-kVEQfQHpaDX8Y1RKIRmlIq3NVhstmPTTNKeTK_l9STrVxt7Wxm5GPn79EoPf-brb-TnE_gq9ps4R8A2"
          />
          <input
            data-val="true"
            data-val-required="The Id field is required."
            id="Id"
            name="Id"
            type="hidden"
            value="b6574625-3b32-ec11-b6e6-000d3adab7a4"
          />
          <div class="form-group icon-down">
            <select
              class="form-control"
              id="ContinuityTrackingEvaluatorNote"
              name="ContinuityTrackingEvaluatorNote"
              validationelement="1"
              v-model="continuityTrackingEvaluatorNote"
            >
              <option value="">Seçiniz...</option>
              <option value="Uygulama devam ediyor">
                Uygulama devam ediyor
              </option>
              <option value="Tek seferlik uygulamaydı">
                Tek seferlik uygulamaydı
              </option>
              <option value="Devam etmiyor">Devam etmiyor</option>
            </select>
          </div>
          <div
            id="ContinuityTrackingEvaluatorNoteError"
            class="form-group invalid-feedback"
            style="display: none"
          >
            Bu alan boş geçilemez!
          </div>
          <div
            class="form-group"
            id="ContinuityTrackingEvaluatorReasonPanel"
            v-if="continuityTrackingEvaluatorNote == 'Devam etmiyor'"
          >
            <textarea
              class="form-control short"
              cols="20"
              id="ContinuityTrackingEvaluatorReason"
              maxlenght="2000"
              name="ContinuityTrackingEvaluatorReason"
              placeholder="Açıklama..."
              rows="2"
              v-model="continuityTrackingEvaluatorReason"
            ></textarea>
          </div>
          <div
            id="ContinuityTrackingEvaluatorReasonError"
            class="form-group invalid-feedback"
            :style="[
              requiredField.includes('continuityTrackingEvaluatorReason')
                ? { display: 'block' }
                : '',
            ]"
          >
            Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
            deneyiniz.
          </div>
          <div class="form-group float-right mt-5">
            <button
              id="SendContinuityTrackingUpdate"
              type="button"
              class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
              @click="sendContinuityTrackingUpdate"
            >
              GÖNDER
            </button>
          </div>
        </form>
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isNil, currentDateTime } from "../../../helpers";
export default {
  name: "ContinuityTracking",
  data() {
    return {
      continuityTrackingEvaluatorNote: "",
      continuityTrackingEvaluatorReason: "",
      requiredField: [],
      minLengthForText: 4,
    };
  },
  props: ["detailData"],
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  created() {
    this.continuityTrackingEvaluatorNote =
      this.detailData.ContinuityTrackingEvaluatorNote;
    this.continuityTrackingEvaluatorReason =
      this.detailData.ContinuityTrackingEvaluatorReason;
  },
  methods: {
    getCurrentDateTime() {
      return currentDateTime();
    },
    sendContinuityTrackingUpdate() {
      this.requiredField = [];
      if (
        isNil(this.continuityTrackingEvaluatorNote) ||
        (this.continuityTrackingEvaluatorNote == "Devam etmiyor" &&
          (isNil(this.continuityTrackingEvaluatorReason) ||
            this.continuityTrackingEvaluatorReason.trim().length <=
              this.minLengthForText))
      ) {
        if (isNil(this.continuityTrackingEvaluatorNote))
          this.requiredField.push("continuityTrackingEvaluatorNote");

        if (
          (this.continuityTrackingEvaluatorNote == "Devam etmiyor" &&
            isNil(this.continuityTrackingEvaluatorReason)) ||
          this.continuityTrackingEvaluatorReason.trim().length <= this.minLengthForText
        )
          this.requiredField.push("continuityTrackingEvaluatorReason");
      } else {
        const tmpData = {
          continuityTrackingEvaluatorNote: this.continuityTrackingEvaluatorNote,
          continuityTrackingEvaluatorReason:
            this.continuityTrackingEvaluatorReason,
        };

        this.$emit("send-continuity-tracking-update", tmpData);
      }
    },
  },
};
</script>